import React, { createContext, useCallback, useMemo } from 'react'
import { Header } from './Header'
import { FileList } from './FileList'

export const FileUploaderContext = createContext(null)

const FileUploader = ({ submitPassword, removeFile, addFiles, files, errors, multiple, accepts, label = 'choose file(s)' }) => {
  const onFilesAdded = useCallback((selectedFiles) => addFiles(selectedFiles), [addFiles])
  const uploaderVisible = useMemo(() => multiple || Object.keys(files || {}).length === 0, [multiple, files])
  const contextValue = useMemo(() => ({ submitPassword, removeFile }), [submitPassword, removeFile])

  return (
    <FileUploaderContext.Provider value={contextValue}>
      <div>
        <div className="dome-file-uploader">
          {uploaderVisible && (
            <Header onFilesAdded={onFilesAdded} multiple={multiple} accepts={accepts}>
              <div className="dome-d-flex dome-align-center dome-justify-center dome-gap6">
                <i className="fa-thin fa-cloud-arrow-up dome-color-dark-grey"></i>
                <span className="dome-p2 dome-color-med-grey">{label}</span>
              </div>
            </Header>
          )}
          <FileList files={files} errors={errors} submitPassword={submitPassword} />
        </div>
      </div>
    </FileUploaderContext.Provider>
  )
}

export default FileUploader
